export const initialState = {
  enabledSso: "",
};

export function SSO_TOGGLE(nextState, { enabledSso }) {
  nextState.enabledSso = enabledSso;
}
